const base_api_url = process.env.VUE_APP_BASE_URL;

const webapi = {
    base_api_url: base_api_url,

    GetEquipmentModelDefine: `${base_api_url}/Archives/GetEquipmentModelDefine`,
    GetPriceTemplates: `${base_api_url}/Archives/GetPriceTemplates`,
    SetEquipmentStatus: `${base_api_url}/Archives/SetEquipmentStatus`,
    AddEquipment: `${base_api_url}/Archives/AddEquipment`,
    PushEvent: `${base_api_url}/Archives/PushEvent`,
    AddEventInfo: `${base_api_url}/Archives/AddEventInfo`,
    AddPaymentMerchant: `${base_api_url}/Archives/AddPaymentMerchant`,
    SetStationStatus2222: `${base_api_url}/Archives/SetStationStatus2222`,
    AddEvcsOperator: `${base_api_url}/Archives/AddEvcsOperator`,
    SetStationStatus2222: `${base_api_url}/Archives/SetStationStatus2222`,
    AddOperator: `${base_api_url}/Archives/AddOperator`,
    QueryPrice: `${base_api_url}/Archives/QueryPrice`,
    SetPriceConnector: `${base_api_url}/Archives/SetPriceConnector`,
    AddPriceTemplate: `${base_api_url}/Archives/AddPriceTemplate`,
    SetStationStatus: `${base_api_url}/Archives/SetStationStatus`,

    GetSelctListByType: `${base_api_url}/Common/GetSelctListByType`,
    DeleteImage: `${base_api_url}/Common/DeleteImage`,

    GetCurrentUserButton: `${base_api_url}/Home/GetCurrentUserButton`,
    GetCurrentUserStations: `${base_api_url}/Home/GetCurrentUserStations`,
    GetCurrentUserInfo: `${base_api_url}/Home/GetCurrentUserInfo`,
    GetUserMenus: `${base_api_url}/Home/GetUserMenus`,
    GetIcpOperator: `${base_api_url}/Home/GetIcpOperator`,
    RefreshToken: `${base_api_url}/Home/RefreshToken`,

    GetChargeOrder: `${base_api_url}/Order/GetChargeOrder`,

    GetRoles: `${base_api_url}/System/GetRoles`,
    ModifyUserInfo: `${base_api_url}/System/ModifyUserInfo`,
    ModifyUserPsw: `${base_api_url}/System/ModifyUserPsw`,

    // 分账管理接口
    GetSplitRules: `${base_api_url}/Split/GetSplitRules`,
    AddSplitRule: `${base_api_url}/Split/AddSplitRule`,
    UpdateSplitRule: `${base_api_url}/Split/UpdateSplitRule`,
    DeleteSplitRule: `${base_api_url}/Split/DeleteSplitRule`,
    UpdateSplitRuleStatus: `${base_api_url}/Split/UpdateSplitRuleStatus`,
};

export default webapi;